import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/api';
import { Table } from '@core/hera-models';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TableDataService {
  constructor(private apiService: ApiService) {}

  fetchTable(shopId: string, tableNumber: string): Observable<Table | null> {
    return this.apiService
      .get(`shops/${shopId}/tables/${tableNumber}`)
      .pipe(catchError(() => of(null)));
  }
}
